import { ErrorOutline, KeyboardArrowDown } from "@mui/icons-material";
import { Button, CircularProgress, Dialog, InputBase, MenuItem, Select } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";

const UpdateUserModal = ({ open, setOpen, users, setUsers,user_data, fetchUsers, sortedRows }) => {
  const [channel, setChannel] = useState({
    channel_type: "email",
  });

  console.log(user_data)


  const[user, setUser] = useState({
    type: user_data.userType,
    organization_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
    user_id : user_data.user_id,
    status: user_data.status
  })
  
 
  const [errorMsg, setErrorMsg] = useState(null);
  const [loader, setLoader] = useState(false);

  const updateUser = async () => {
    setLoader(true);
      let check= await axios.post(`${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,{
                      userId: JSON.parse(localStorage.getItem('user')).userId.S
                  });
                  
                  if (check.status ===  200) {
                    const user___ = check.data.user;
                    
              
                    if(user___.relatedOrgs.L?.find((e)=> e?.M.org_id?.S ===  JSON.parse(localStorage.getItem('organization')).orgId.S)){
                        
                      try {
                        
                        console.log({user})
                  
                        let user_data_ = await axios.post(
                          process.env.REACT_APP_BACKEND_URL + "update-user",
                          {...user, updatingUserId:JSON.parse(localStorage.getItem('user')).userId.S}
                        )
                  
                        localStorage.setItem('organization', JSON.stringify(user_data_.data.updatedItem) )
                  
                        
                  
                  
                        
                  
                        setOpen(false)
                        
                  
                    
                       
                  
                        setUsers((prevUsers) =>
                        prevUsers.map((existingUser) =>
                          existingUser.user_id ===  user_data.user_id
                            ? {
                                ...existingUser, // Retain existing fields
                                userType: user.type, // Update userType
                                status: user.status, // Update status
                              }
                            : existingUser // Keep other users unchanged
                        )
                  
                  
                      );
                  
                  
                      fetchUsers()
                      
                      } catch (error) {
                        console.log(error);
                        if (error.response && error.response.data) {
                          console.error("Response data:", error.response.data);
                          setErrorMsg(error.response.data.error);
                        }
                        setLoader(false);
                      }
                    }else{
                      window.location.reload()
                    }
          
                  }
  };
  return (
    <Dialog open={open} fullWidth={true} maxWidth={"sm"}
    BackdropProps={{
      style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
    }}
    >
      <div className="lg:px-8 px-4 py-6">

      {errorMsg && (
        <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold mb-3">
          <ErrorOutline sx={{ fontSize: "" }} /> {errorMsg}
        </div>
      )}

        <div className="lg:text-[16px]  text-[15px] font-semibold mb-4"> Edit User</div>
        <div className="flex justify-center">
          <div className="lg:space-y-5 space-y-3">
            <div className="grid lg:grid-cols-3 items-center lg:space-x-10 lg:space-y-0 space-y-2">
              <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                User Type{" "}
              </div>

              <div className="lg:w-[300px] w-full">
                <Select
                  IconComponent={KeyboardArrowDown}
                  fullWidth
                  defaultValue={user.type}
                  value={user.type}
                  onChange={(e) => {
                    setUser({ ...user, type: e.target.value });
                  }}
                  className="mb-2 bg-[#F7F7F8]"
                  sx={{
                    fontSize: "14px",
                    padding: "4px 8px", // Adjust padding here
                    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                    "& .MuiSelect-select": {
                      padding: "4px 8px", // Adjust padding for the text inside Select
                    },
                  }}
                >
                  <MenuItem value="admin">Admin</MenuItem>
                  <MenuItem value="user">User</MenuItem>

                  {
                    (sortedRows.filter((e)=> e.email ===  JSON.parse(localStorage.getItem('user')).email.S)[0].userType  !=='owner'  )? '' 
                    :<MenuItem value="owner">Owner</MenuItem>
                  }
                  
                </Select>
              </div>
            </div>

            <div className="grid lg:grid-cols-3 items-center lg:space-x-10 lg:space-y-0 space-y-2">
              <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                User Status
              </div>

              <div className="lg:w-[300px] w-full">
                <Select
                  IconComponent={KeyboardArrowDown}
                  fullWidth
                  defaultValue={user.status}
                  value={user.status}
                  onChange={(e) => {
                    setUser({ ...user, status: e.target.value });
                  }}
                  className="mb-2 bg-[#F7F7F8]"
                  sx={{
                    fontSize: "14px",
                    padding: "4px 8px", // Adjust padding here
                    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                    "& .MuiSelect-select": {
                      padding: "4px 8px", // Adjust padding for the text inside Select
                    },
                  }}
                >
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                </Select>
              </div>
            </div>
            
            

            <div className="flex justify-center pt-6 pb-4 space-x-2">
              <Button
                sx={{
                  textTransform: "none",
                  color: "#605BFF",
                  bgcolor: "white",
                  py: "4px",
                  px: "40px",
                  borderRadius: "7px",
                  fontSize: {lg:"14px", xs:"13px"},
                }}
                onClick={() => {
                  setOpen(false);
                }}
              >
                Close
              </Button>

              <Button
                sx={{
                  textTransform: "none",
                  bgcolor: "#605BFF",
                  color: "white",
                  py: "4px",
                  px: "40px",
                  borderRadius: "7px",
                  fontSize: {lg:"14px", xs:"13px"},
                }}

                onClick={()=>{
                  
                  updateUser()
                }}
                disabled={loader}
              >
                {loader? (
                          <CircularProgress
                            size={"1.3rem"}
                            sx={{ color: "white" }}
                          />
                        ) : (
                          " Save"
                        )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default UpdateUserModal;
